import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import omit from 'lodash/omit';
import { forwardRef, useId, useImperativeHandle, useRef } from 'react';
import { styled } from 'styled-components';
import { __ } from '@design-system/i18n';
import { useMatchBreakpoint, useTheme, zIndices } from '@design-system/theme';
import { CloseButton } from './components/CloseButton';
import { Scroll } from './components/Scroll';
import { useDialog } from './hooks/useDialog';
export const Dialog = forwardRef((_a, inputRef) => {
    var { allowPinchZoom = false, ariaLabelledby, canDismissOnEsc = true, center = false, children, closeButtonText = __('Close'), dataTestId = 'ds-dialog', isModal = false, isOpen, onDismiss } = _a, props = __rest(_a, ["allowPinchZoom", "ariaLabelledby", "canDismissOnEsc", "center", "children", "closeButtonText", "dataTestId", "isModal", "isOpen", "onDismiss"]);
    const isSmall = useMatchBreakpoint('s');
    const ref = useRef(null);
    const labelledby = useId().replace(/[^a-zA-Z]/gu, '');
    const labelledbyId = ariaLabelledby !== null && ariaLabelledby !== void 0 ? ariaLabelledby : labelledby;
    useImperativeHandle(inputRef, () => ref.current, [ref]);
    const { handleClose, handleKeyDown } = useDialog({
        allowPinchZoom,
        canDismissOnEsc,
        isModal,
        isOpen,
        onDismiss,
        ref,
    });
    const theme = useTheme();
    const modalCalc = `calc(var(--viewport-height, 100vh) - var(--modal-top-${labelledbyId}, 0) - var(--modal-head-${labelledbyId}, 0) - var(--modal-foot-${labelledbyId}, 0))`;
    const modalTop = `${theme.space[center || isSmall ? 0 : 13]}px`;
    const style = {
        '--modal-calc': modalCalc,
        [`--modal-calc-${labelledbyId}`]: modalCalc,
        '--modal-top': modalTop,
        [`--modal-top-${labelledbyId}`]: modalTop,
    };
    return (_jsx(DialogStyled, { "$center": center, "aria-labelledby": labelledbyId, "aria-modal": isModal ? 'true' : undefined, "data-isopen": isOpen, "data-testid": dataTestId, onKeyDown: handleKeyDown, ref: ref, style: style, theme: theme, children: _jsxs(Scroll, Object.assign({ "$center": center, property: `modal-top-${labelledbyId}`, theme: theme }, omit(props, 'ref'), { children: [_jsx(CloseButton, { onClick: handleClose, screenReadersText: closeButtonText }), children] })) }));
});
const DialogStyled = styled.dialog `
  align-items: ${({ $center }) => ($center ? 'center' : 'flex-start')};
  background-color: transparent;
  border: 0;
  bottom: 0;
  justify-content: center;
  left: 0;
  margin: 0;
  max-height: var(--viewport-height, 100vh);
  max-width: var(--viewport-width, 100vw);
  min-height: var(--viewport-height, 100vh);
  min-width: var(--viewport-width, 100vw);
  padding: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: ${({ zIndex = zIndices.modal }) => zIndex};
  &[open] {
    display: flex;
  }
  &::backdrop {
    background-color: ${({ theme }) => theme.colors.fog};
  }
`;
//# sourceMappingURL=Dialog.js.map